import { IInvoice } from 'models';
import moment from 'moment';
import { GetContactName } from 'redux/actions/contacts';
import { ECrudType } from 'redux/actions/crud';
import { EActions } from 'redux/actions/EActions';
import { GetReducer } from './crud';

export const getInvoiceStatus = (obj: IInvoice) => {
  if (obj.invoiceStatus === 'Unpaid') {
    if (moment().diff(moment(obj.dueDate)) > 0) return 'Overdue';
  }
  return obj.invoiceStatus;
};

const reducer = GetReducer(
  ECrudType.invoices,
  (obj: any) => {
    return {
      ...obj,
      date: moment(obj.date),
      dueDate: moment(obj.dueDate),
      invoiceStatus: getInvoiceStatus(obj),
      contact: {
        ...obj.contact,
        name: GetContactName(obj.contact),
      },
    };
  },
  undefined,
  (state: any, action: any) => {
    switch (action.type) {
      case ECrudType.invoices + '_' + EActions.PAYMENT_SUCCESS:
        return { ...state, isLoading: false, paymentSuccess: true, reload: true };
      case ECrudType.invoices + '_' + EActions.CRUD_CLEANUP:
        return {
          ...state,
          showModal: false,
          list: [],
          saved: undefined,
          one: undefined,
          recipients: [],
          notifySuccess: false,
          paymentSuccess: false,
          reload: false,
        };
    }
  },
);

export default reducer;
